// app/src/utils/normalizeCars.ts
import { OccupancyState } from "../components/icons/Occupancy";

type CarsNested = OccupancyState[][];
type CarsFirestore = Array<{ group?: number; cars?: Record<string, OccupancyState> }>;

export function normalizeCars(input: any): CarsNested {
  if (!input) return [];

  // Already nested arrays? return as-is
  if (Array.isArray(input) && input.length > 0 && Array.isArray(input[0])) {
    return input as CarsNested;
  }

  // Firestore shape: [{group:0, cars:{car_1:"low",...}}, ...]
  if (Array.isArray(input) && input.length > 0 && typeof input[0] === "object") {
    const groups = input as CarsFirestore;

    const sorted = [...groups].sort(
      (a, b) => (a.group ?? 0) - (b.group ?? 0)
    );

    return sorted.map((g) => {
      const carsMap = g.cars ?? {};
      const keys = Object.keys(carsMap).sort((a, b) => {
        // car_1, car_2 ... numeric order
        const na = parseInt(a.replace("car_", ""), 10);
        const nb = parseInt(b.replace("car_", ""), 10);
        return na - nb;
      });
      return keys.map((k) => carsMap[k] ?? "low");
    });
  }

  return [];
}